module.exports = __webpack_public_path__ + "assets/images/rbyearend-21-desktop.jpg?v=5716bbab";